import request from "api/request";

export const registerDevice = (data, auth) =>
  request({
    url: "api/v1/notifications/register-device/",
    method: "POST",
    data,
    auth,
  });

export const updateNotificationInteraction = (notificationId, interactionType, auth, isChatNotification = false) => {
  // Determine endpoint based on notification type
  const endpoint = isChatNotification
    ? `api/v1/notifications/chat/${notificationId}/`
    : `api/v1/notifications/events/${notificationId}/`;

  return request({
    url: endpoint,
    method: "PATCH",
    data: { interaction_type: interactionType },
    auth,
  });
};
